export const validators = {
	data() {
		return {
			validators: {
				regNumber: {
					required: true
				},
				regDate: {
					date_format: 'dd-MM-yyyy',
					before: '01-01-2115',
					after: '01-01-2000',
					required: true
				},
				expireDate: {
					date_format: 'dd-MM-yyyy',
					before: '01-01-2115',
					after: '01-01-2000',
					required: true
				},
				fromDepartment: {
					required: true
				},
				toDepartment: {
					required: true
				},
			}
		}
	},

	methods: {
		checkField(name) {
			const valid = Object.keys(this.validationFields).some(() =>  this.validationFields[name].valid );
			const touched = Object.keys(this.validationFields).some(() =>  this.validationFields[name].touched );
			const changed = Object.keys(this.validationFields).some(() =>  this.validationFields[name].changed );
			const dirty = Object.keys(this.validationFields).some(() =>  this.validationFields[name].dirty );

			if (valid && changed) {
				return true;
			}
			if (touched && valid) {
				return true;
			}
			if (touched && !valid) {
				return false
			}
			if (changed && !valid) {
				return false
			}
			if (dirty && !valid) {
				return false
			}
			return null;

		}
	}
};
